export default import.meta.ROLLDOWN_FILE_URL_kzAB80vXE9YGCOqDVaRJ_A